module.exports = __webpack_public_path__ + "static/media/badfit.a49b1d08.png";